<div class="modal-header">
    <h3 class="modal-title">What would you like to do?</h3>
</div>
<div class="modal-body">
    <div class="radio clip-radio radio-primary radio-inline margin-left-10">
        <input legacy-css type="radio" value="order" id="radioorder" [(ngModel)]="option" [ngModelOptions]="{ standalone: true }" />
        <label for="radioorder"
            >Remove order <strong>{{ order.OrderNumberString }}</strong> from invoice '{{ $any(order.JobPayment).Description }}'</label
        >
    </div>
    <div class="radio clip-radio radio-primary radio-inline margin-left-10">
        <input legacy-css type="radio" value="invoice" id="radioinvoice" [(ngModel)]="option" [ngModelOptions]="{ standalone: true }" />
        <label for="radioinvoice"
            >Delete invoice '{{ $any(order.JobPayment).Description }}' and <strong>remove all orders</strong> attached</label
        >
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-bx-alert" (click)="ok()">{{ option === 'order' ? 'Remove order' : 'Delete invoice' }}</button>
</div>
